export enum EGalleryTypes {
    image = 'image',
    slider = 'slider',
    video = 'video',
    carousel = 'carousel',
    grid = 'grid',
    collage = 'collage',
}

export enum EVideoTypes {
    youtube = 'youtube',
    vimeo = 'vimeo',
    fileManager = 'fileManager',
}

export enum EGalleryAttachment {
    contain = 'contain',
    cover = 'cover',
}
